import Translate from "../../../components/Translate";
import {Link} from "react-router-dom";
import React from "react";
import {ARCHIVIO_TIPO_VEICOLO_AUTO, ARCHIVIO_TIPO_VEICOLO_MOTO} from "../../../utility/common";

export default function MenuArchivio({
                                            showArchivio,
                                        }) {

    return showArchivio && (
        <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="archivio"
               role="button"
               data-bs-toggle="dropdown" aria-expanded="false">
                <i className="fas fa-photo-video"/>
                <Translate>Archivio</Translate>
            </a>
            <ul className="dropdown-menu" aria-labelledby="archivio">
                <li>
                    <Link to={`/archivio/${ARCHIVIO_TIPO_VEICOLO_AUTO}`} className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-car"/>
                            <Translate>Auto</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to={`/archivio/${ARCHIVIO_TIPO_VEICOLO_MOTO}`} className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-motorcycle"/>
                            <Translate>Moto</Translate>
                        </div>
                    </Link>
                </li>
            </ul>
        </li>
    );
}